import { Component, Input } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { ToolsProvider } from '../../providers/tools/tools';
import { ModalController } from 'ionic-angular';

@Component({
  selector: 'all-badges',
  templateUrl: 'all-badges.html',
})
export class AllBadgesComponent {
  log = debug('app:AllBadgesComponent');

  @Input()
  user;

  @Input()
  lastN: Number;

  @Input()
  showAll = false;

  @Input()
  allowOpen = false;

  @Input()
  smallIcons = false;

  totalDisplayedLocationEarned = 0;
  totalDisplayLocationUnearned = 0;
  // Use an increment diviable by 12, so it looks
  // reasonable at 3 and 4 columns wide
  incrementLocationBadgeDisplay = 24;
  totalLocationsEarned = 0;
  totalLocationsUnearned = 0;

  groups = [
    {
      title: 'Leaderboard',
      pipe: 'leaderboard',
    },
    {
      title: 'Engagement',
      pipe: 'engagement',
    },
    {
      title: 'Assigned From CDLLife Team',
      pipe: 'admin',
    },
    {
      title: 'Location',
      pipe: 'location',
    },
  ];

  otherBadges = [];
  allBadges = [];
  loading = true;

  constructor(public tools: ToolsProvider, public modalCtrl: ModalController) {
    this.log('constructed');
  }

  ngOnInit() {
    this.setOtherBadges();
  }

  private async setOtherBadges() {
    try {
      const res = await this.tools.getBadges();
      const userBadges = _.get(this.user, 'userBadges');
      // add variable to sort badges by earned
      this.allBadges = _.map(res.data, b => {
        _.set(b, 'hasEarned', _.includes(userBadges, b.id));
        return b;
      });
      this.allBadges = _.sortBy(this.allBadges, ['hasEarned', 'shortTitle']);
      this.updateLocationCount();
      this.otherBadges = _.filter(this.allBadges, badge => {
        return !badge.hasEarned && badge.id !== 'Inactive';
      });

      this.showMoreLocationBadges();
    } catch (error) {
      this.log('error getting badges');
    } finally {
      this.loading = false;
    }
  }

  private updateLocationCount() {
    const totalLocations = _.get(
      _.countBy(this.allBadges, b => b.location),
      'true'
    );
    this.totalLocationsEarned = _.get(
      _.countBy(this.allBadges, b => b.location && b.hasEarned),
      'true'
    );
    this.totalLocationsUnearned = totalLocations - this.totalLocationsEarned;
  }

  openBadge(badgeId, hasBadge) {
    if (!this.allowOpen) {
      return;
    }
    if (window['event']) {
      event.stopPropagation();
    }

    const modal = this.modalCtrl.create('BadgeDetailPage', {
      badgeId: badgeId,
      user: this.user,
      userHasBadge: hasBadge,
    });
    modal.onDidDismiss(() => {
      this.log('will reset other badges', this.user);
      this.setOtherBadges();
    });
    modal.present();
  }

  showMoreLocationBadges() {
    this.allowOpen = false;

    let increment = this.incrementLocationBadgeDisplay;

    if (this.totalLocationsEarned > this.totalDisplayedLocationEarned) {
      if (
        this.totalLocationsEarned - this.totalDisplayedLocationEarned >=
        increment
      ) {
        this.totalDisplayedLocationEarned =
          this.totalDisplayedLocationEarned + increment;
        return;
      } else {
        increment =
          increment -
          (this.totalLocationsEarned - this.totalDisplayedLocationEarned);
        this.totalDisplayedLocationEarned = this.totalLocationsEarned;
      }
    }

    this.totalDisplayLocationUnearned =
      this.totalDisplayLocationUnearned + increment;
    setTimeout(() => {
      this.allowOpen = true;
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/components/all-badges/all-badges.ts